import { render } from "./NotFound.vue?vue&type=template&id=d73c19c4&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=d73c19c4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/space-tourism-website-main-VueJs/cli-version/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d73c19c4"]])

export default __exports__